import type { ReactNode } from "react";

import { haptic } from "../lib/telegram";

interface Props {
  title: string;
  subtitle?: string;
  onBack: () => void;
  children: ReactNode;
}

export function GameShell({ title, subtitle, onBack, children }: Props) {
  return (
    <div className="space-y-4">
      <button
        type="button"
        onClick={() => {
          haptic.select();
          onBack();
        }}
        className="flex items-center gap-2 text-sm font-bold text-white/50 active:text-white"
      >
        <span aria-hidden>‹</span>
        Назад
      </button>
      <div>
        <h2 className="text-xl font-extrabold text-white">{title}</h2>
        {subtitle && <p className="mt-1 text-xs leading-relaxed text-white/45">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}
